import { ProductTestingEntity } from "@/mk2/apps/forum/schemas";
import { APIFailureAction, APIRequestAction, APISuccessAction } from "@/mk2/helpers/action";
import { NormalizedResponse } from "@/mk2/helpers/api";

export const TESTING_DETAIL_FETCH_TRIGGER = "TESTING_DETAIL_FETCH_TRIGGER";
export interface TestingDetailFetchTriggerAction {
    readonly type: typeof TESTING_DETAIL_FETCH_TRIGGER;
    readonly testingHashtag: string;
}
export const TESTING_DETAIL_FETCH_REQUEST = "TESTING_DETAIL_FETCH_REQUEST";
export interface TestingDetailFetchRequestAction extends APIRequestAction {
    readonly type: typeof TESTING_DETAIL_FETCH_REQUEST;
    readonly testingHashtag: string;
}
export interface TestingDetailFetchNormalizedResponse extends NormalizedResponse {
    readonly result: { testing: number; testersPosts: number[] };
}
export const TESTING_DETAIL_FETCH_SUCCESS = "TESTING_DETAIL_FETCH_SUCCESS";
export interface TestingDetailFetchSuccessAction extends APISuccessAction<TestingDetailFetchNormalizedResponse> {
    readonly type: typeof TESTING_DETAIL_FETCH_SUCCESS;
    readonly testingHashtag: string;
}
export const TESTING_DETAIL_FETCH_FAILURE = "TESTING_DETAIL_FETCH_FAILURE";
export interface TestingDetailFetchFailureAction extends APIFailureAction {
    readonly type: typeof TESTING_DETAIL_FETCH_FAILURE;
    readonly testingHashtag: string;
}

export const testingDetailFetchTrigger = (
    testingHashtag: string,
): TestingDetailFetchTriggerAction => ({
    type: TESTING_DETAIL_FETCH_TRIGGER,
    testingHashtag,
});
export const testingDetailFetchApi = {
    request: (testingHashtag: string): TestingDetailFetchRequestAction => ({
        type: TESTING_DETAIL_FETCH_REQUEST,
        testingHashtag,
    }),
    success: (
        testingHashtag: string,
        response: TestingDetailFetchNormalizedResponse,
    ): TestingDetailFetchSuccessAction => ({
        type: TESTING_DETAIL_FETCH_SUCCESS,
        testingHashtag,
        response,
    }),
    failure: (testingHashtag: string, error: any): TestingDetailFetchFailureAction => ({
        type: TESTING_DETAIL_FETCH_FAILURE,
        testingHashtag,
        error,
    }),
};
